import { useAuthStoreShallow } from "@/features/authentication";
import { useDebounceValue } from "usehooks-ts";
import { useAnalyticsStoreShallow } from "../store/analytics.store";

const useGetQueryData = (skipDebounce = false) => {
  const isUserOrCreatorLite = useAuthStoreShallow((s) => s.isUserOrCreatorLite);
  const data = useAnalyticsStoreShallow((s) => ({
    location: s.location,
    storyId: s.story.id,
    versionId: s.version.id,
    userId: s.user.id,
    dateFrom: s.date.dateFrom,
    dateTo: s.date.dateTo,
    showUnread: s.showUnread,
    folderId: s.folder.id,
  }));

  const [debouncedData] = useDebounceValue(data, 250);
  const queryData = skipDebounce ? data : debouncedData;
  return { ...queryData, creator: isUserOrCreatorLite };
};

export default useGetQueryData;
